import { render, staticRenderFns } from "./ProducersList.vue?vue&type=template&id=0c89d8e8&"
import script from "./ProducersList.vue?vue&type=script&lang=js&"
export * from "./ProducersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports